module.exports = __webpack_public_path__ + "img/ambassadors-popup-header.ded7cb70.svg";